import { COMPANY_SELECTED } from '../actions/actionTypes';

const initialState = {
  // name: '',
  // id: '',
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_SELECTED:
      state = action?.data;
      return state;
    default:
      return state;
  }
};

export default companyReducer;
